import { computed, ref } from 'vue'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export function useLocation() {
  const country = ref<string>('')
  const state = ref<string>('')

  const countriesWithZipCodeLabel = ['US']
  const countriesWithProvinces = ['CA']
  const countriesWithoutPostcode = ['AE']

  const getCountries = computed(() =>
    Object.keys(countriesGlobalVar).map((cca2) => ({
      value: cca2,
      label: countriesGlobalVar[cca2],
    })),
  )

  const getStates = computed(() => {
    if (!country.value) {
      return []
    }

    const states = globalStates[country.value] ?? []

    return Object.keys(states).map((cca2) => ({
      value: cca2,
      label: states[cca2],
    }))
  })

  const setSelectedCountry = (selectedCountry: string) => {
    country.value = selectedCountry
  }

  const setSelectedState = (selectedState: string) => {
    state.value = selectedState
  }

  const postCodeLabel = computed(() =>
    countriesWithZipCodeLabel.includes(country.value ?? '') ? $t('ZIP code') : $t('Postcode'),
  )
  const postCodePlaceholder = computed(() =>
    countriesWithZipCodeLabel.includes(country.value ?? '') ? $t('ZIP code') : $t('Postcode'),
  )

  const stateLabel = computed(() =>
    countriesWithProvinces.includes(country.value ?? '') ? $t('Province') : $t('State'),
  )
  const statePlaceholder = computed(() =>
    countriesWithProvinces.includes(country.value ?? '')
      ? $t('Select a province')
      : $t('Select a state'),
  )

  const countryHasStates = computed(() => getStates.value.length > 0)

  const countryHasPostcode = computed(() => !countriesWithoutPostcode.includes(country.value ?? ''))

  return {
    getCountries,
    getStates,

    setSelectedCountry,
    setSelectedState,

    postCodeLabel,
    postCodePlaceholder,

    stateLabel,
    statePlaceholder,

    countryHasStates,
    countryHasPostcode,
  }
}
